
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 7.25c7.042 0 12.75 5.708 12.75 12.75S27.042 32.75 20 32.75 7.25 27.042 7.25 20 12.958 7.25 20 7.25zm0 1.5C13.787 8.75 8.75 13.787 8.75 20S13.787 31.25 20 31.25 31.25 26.213 31.25 20 26.213 8.75 20 8.75zm0 1.27c5.512 0 9.98 4.468 9.98 9.98 0 5.512-4.468 9.98-9.98 9.98-5.512 0-9.98-4.468-9.98-9.98 0-5.512 4.468-9.98 9.98-9.98zm0 1.5a8.48 8.48 0 100 16.96 8.48 8.48 0 000-16.96zm1.713 11.336a2.423 2.423 0 11-3.426 3.426 2.423 2.423 0 013.426-3.426zm-2.366 1.06a.923.923 0 101.306 1.306.923.923 0 00-1.306-1.306zm6.935-5.63a2.423 2.423 0 11-3.426 3.427 2.423 2.423 0 013.426-3.426zm-9.138 0a2.423 2.423 0 11-3.426 3.427 2.423 2.423 0 013.426-3.426zm6.772 1.061a.923.923 0 101.306 1.306.923.923 0 00-1.306-1.306zm-9.138 0a.923.923 0 101.306 1.306.923.923 0 00-1.306-1.306zm6.935-5.63a2.423 2.423 0 11-3.426 3.427 2.423 2.423 0 013.426-3.426zm-2.366 1.061a.923.923 0 101.306 1.306.923.923 0 00-1.306-1.306z","fill":"#409EFF"}})])
          )
        }
      }
    